import { EditorOptions } from '@lyearn/lygo-core';

export default function plugins(props: EditorOptions) {
  return [];
}
